import { render, staticRenderFns } from "./ClinicalSkillsOverview.vue?vue&type=template&id=dc57f080&scoped=true"
import script from "./ClinicalSkillsOverview.vue?vue&type=script&lang=js"
export * from "./ClinicalSkillsOverview.vue?vue&type=script&lang=js"
import style0 from "./ClinicalSkillsOverview.vue?vue&type=style&index=0&id=dc57f080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc57f080",
  null
  
)

export default component.exports